<template>
  <a v-if="url" :target="target" :href="url">
    <img
      :src="imageSource"
      :srcset="srcset"
      class="img-fluid"
      :class="className"
      :alt="alternateText"
      :style="styles"
    />
  </a>
  <img
    v-else
    :src="imageSource"
    :srcset="srcset"
    class="img-fluid"
    :class="className"
    :alt="alternateText"
    :style="styles"
  />
</template>

<script>
export default {
  name: "square-image",
  props: {
    target: String,
    imageSource: {
      type: String,
      default: "@/assets/logo.png"
    },
    imageSource2x: {
      type: String
    },
    imageSource3x: {
      type: String
    },
    alternateText: {
      type: String,
      default: "Sample Image"
    },
    url: {
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    className: String
  },
  computed: {
    srcset() {
      if (this.imageSource3x) {
        return `${this.imageSource} 1x, ${this.imageSource2x} 2x, ${this.imageSource3x} 3x`;
      } else if (this.imageSource2x) {
        return `${this.imageSource} 1x, ${this.imageSource2x} 2x`;
      }
      return `${this.imageSource} 1x`;
    }
  }
};
</script>

<style>
img[data-field-type="square-image"] {
  object-fit: cover;
}
.over-first {
  position: absolute;
  right: -3%;
  bottom: 0;
}

@media (max-width: 991px) {
  .over-first {
    bottom: 2%;
  }
}
</style>
